const UI_VERSION_VALUES = new Set([1, 2, 3]);

const normalizeHash = (hash) => {
  if (typeof hash !== 'string' || !hash.trim()) return '#/';
  const trimmed = hash.trim();
  const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  const [pathOnly] = withHash.split('?');
  return pathOnly || '#/';
};

export const resolveUiVersion = (user) => {
  const candidate = user?.uiVersion;
  if (typeof candidate === 'number' && Number.isInteger(candidate) && UI_VERSION_VALUES.has(candidate)) {
    return candidate;
  }
  if (typeof candidate === 'string') {
    const trimmed = candidate.trim();
    if (trimmed) {
      const parsed = Number(trimmed);
      if (Number.isInteger(parsed) && UI_VERSION_VALUES.has(parsed)) {
        return parsed;
      }
    }
  }
  return 1;
};

export const canAccessLive = (user) => resolveUiVersion(user) >= 2;

export const canAccessAppFactory = (user) => {
  if (resolveUiVersion(user) < 3) return false;
  return user?.role === 'admin' || user?.role === 'appEntwickler';
};

export const isRouteAllowed = (hash, user) => {
  if (!user) return true;
  const cleanHash = normalizeHash(hash);

  if (cleanHash === '#/upload') {
    return false;
  }
  if (/^#\/live\/share\/[^/]+$/.test(cleanHash)) {
    return true;
  }
  if (/^#\/live(?:\/.*)?$/.test(cleanHash)) {
    return canAccessLive(user);
  }
  if (/^#\/app-factory(?:\/.*)?$/.test(cleanHash)) {
    return canAccessAppFactory(user);
  }
  return true;
};
